export default "__VITE_ASSET__CwmokRHw__"